var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWechat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.42122 11.7504C6.38796 12.3745 6.2347 11.4001 6.2347 11.4001L4.93977 8.12703C4.44141 6.57166 5.37095 7.42577 5.37095 7.42577C5.37095 7.42577 6.16851 8.07929 6.77388 8.47745C7.37882 8.87588 8.0684 8.59451 8.0684 8.59451L16.5345 4.36178C14.9723 2.25642 12.3923 0.880005 9.47107 0.880005C4.70401 0.880005 0.839966 4.5432 0.839966 9.06232C0.839966 11.662 2.11934 13.9752 4.11248 15.4746L3.75299 17.7127C3.75299 17.7127 3.57767 18.366 4.18499 18.063C4.59872 17.8565 5.65354 17.1157 6.28146 16.6655C7.30111 17.0497 8.38195 17.246 9.47158 17.2448C14.2382 17.2448 18.1031 13.5816 18.1031 9.06248C18.1031 7.75357 17.7774 6.51741 17.2006 5.42003C14.5031 7.17776 8.22957 11.263 7.42122 11.7504Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWechat);
export default __webpack_public_path__ + "static/media/wechat.1f386375.svg";
export { ForwardRef as ReactComponent };